import { useSelector } from 'react-redux'
import { ClientUser } from '@weblite/ts-action/client-user'
import { clientUserView } from '$logic/client-user/storage'

export function useClientUser() {
  return useSelector(clientUserView) || ({} as ClientUser)
}
